/**
 * @generated SignedSource<<102f8bfaa37fec3d9fcce36719c9180c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type loginAzureActiveDirectory_viewer$data = {
  readonly id: string;
  readonly actualPersonId: string | null;
  readonly company: {
    readonly AADTenant: string | null;
  } | null;
  readonly " $fragmentType": "loginAzureActiveDirectory_viewer";
};
export type loginAzureActiveDirectory_viewer$key = {
  readonly " $data"?: loginAzureActiveDirectory_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"loginAzureActiveDirectory_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "loginAzureActiveDirectory_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADTenant",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "488bb1f42fe72d32fe7783ebf8bac525";

export default node;
